import Avatar from '@material-ui/core/Avatar'
import Button from '@material-ui/core/Button'
import Container from '@material-ui/core/Container'
import FormHelperText from '@material-ui/core/FormHelperText'
import { makeStyles } from '@material-ui/core/styles'
import TextField from '@material-ui/core/TextField'
import Typography from '@material-ui/core/Typography'
import Lock from '@material-ui/icons/Lock'
import React, { useState } from 'react'
import requestAccessToken from './services/requestAccessToken'

const useStyles = makeStyles((theme) => ({
  // '@global': {
  //   body: {
  //     backgroundColor: theme.palette.common.white,
  //   },
  // },
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}))

export default function LoginPage() {
  const classes = useStyles()

  const [authenticationErrorMessage, setAuthenticationErrorMessage] = useState(
    null
  )
  const [loading, setLoading] = useState(false)

  const handleLogin = async (e: React.MouseEvent) => {
    e.preventDefault()

    try {
      const formData = new FormData(document.forms[0])
      const email = formData.get('email')
      const password = formData.get('password')
      if (typeof email === 'string' && typeof password === 'string') {
        setLoading(true)
        setAuthenticationErrorMessage(null)
        await requestAccessToken({ email, password })
        window.location.href = '/'
      }
    } catch (e) {
      setAuthenticationErrorMessage(e.message)
    } finally {
      setLoading(false)
    }
  }

  return (
    <Container component='main' maxWidth='xs'>
      <div className={classes.paper}>
        <Avatar className={classes.avatar}>
          <Lock />
        </Avatar>
        <Typography component='h1' variant='h5'>
          Sign in
        </Typography>
        <form className={classes.form} noValidate action='' method='post'>
          <TextField
            variant='outlined'
            margin='normal'
            required
            fullWidth
            label='Email Address'
            name='email'
            autoComplete='email'
            autoFocus
          />
          <TextField
            variant='outlined'
            margin='normal'
            required
            fullWidth
            name='password'
            label='Password'
            type='password'
            autoComplete='current-password'
          />
          <Button
            type='submit'
            disabled={loading}
            fullWidth
            variant='contained'
            color='primary'
            className={classes.submit}
            onClick={handleLogin}>
            {loading ? '...' : 'Log In'}
          </Button>
          {authenticationErrorMessage && (
            <FormHelperText error={true}>
              {authenticationErrorMessage}
            </FormHelperText>
          )}
        </form>
      </div>
    </Container>
  )
}
